module.exports = __webpack_public_path__ + "img/a585f28.svg";